module.exports = __webpack_public_path__ + "static/media/two.7a84c169.svg";